import { render, staticRenderFns } from "./admin-manufacturer.vue?vue&type=template&id=f9e13872&"
import script from "./admin-manufacturer.vue?vue&type=script&lang=js&"
export * from "./admin-manufacturer.vue?vue&type=script&lang=js&"
import style0 from "./admin-manufacturer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports